<template>
<div>
    <v-server-table v-if="!savedFilterId || (savedFilterId && savedFilter)" ref="incidentTypeTable" url="/dash/grouped-incidents" :columns="columns" :options="options">

        <template slot="IncidentTypeId" slot-scope="props">
            {{ props.row.IncidentTypeName }}
        </template>
    </v-server-table>
</div>
</template>

<script>
export default {
    props: ['timeFilter', 'savedFilterId'],

    data: function() {
        return {
            savedFilter: null,
            columns: ['IncidentTypeId', 'incident_count'],
            options: {
                headings: {
                    IncidentTypeId: 'Employee',
                    incident_count: '# of Incidents',
                },
                orderBy: {
                    ascending: false,
                    column: 'incident_count',
                },
                responseAdapter: (response) => {
                    //Emit the count
                    this.$emit('incidentTypeListCount', this.calcIncidentCount(response.data.data));

                    //Send it
                    return response.data;
                },
                requestAdapter: (data) => {
                    if(this.savedFilter)
                    {
                        //Get the config
                        var tableConfig = JSON.parse(this.savedFilter.table_config);

                        data.limit = (tableConfig.limit ? tableConfig.limit : 25);
                        data.query = tableConfig.query;
                        data.orderBy = tableConfig.orderBy;
                        data.ascending = tableConfig.ascending;

                        data.filters = this.extractFilters();
                    }
                    else
                    {
                        //Set the filters
                        data.filters = {
                            'incident.IncidentDate': this.timeFilter.toLowerCase(),
                        };
                    }

                    data.groupType = 'IncidentType';

                    this.getPreviousData();

                    //Send it
                    return data;
                },
                uniqueKey: 'IncidentTypeId',
            },
        }
    },

    methods: {
        refresh: function() {
            this.$refs.incidentTypeTable.refresh();
        },
        extractFilters: function() {
            let filters = {
                'incident.IncidentTypeId': [],
                'incident.InjuryTypeId': [],
                'jobsite.DivisionId': [],
                'incident.IncidentDate': "",
                'incident.JobsiteId': {},
            };

            let table_filters = JSON.parse(this.savedFilter.table_filters);

            for (var i = 0; i < table_filters['incident.IncidentTypeId'].length; i++) {
                //Add each id
                filters['incident.IncidentTypeId'].push(table_filters['incident.IncidentTypeId'][i]['id']);
            }

            for (var i = 0; i < table_filters['incident.InjuryTypeId'].length; i++) {
                //Add each id
                filters['incident.InjuryTypeId'].push(table_filters['incident.InjuryTypeId'][i]['id']);
            }

            for (var i = 0; i < table_filters['jobsite.DivisionId'].length; i++) {
                //Add each id
                filters['jobsite.DivisionId'].push(table_filters['jobsite.DivisionId'][i]['id']);
            }

            filters['incident.IncidentDate'] = table_filters['incident.IncidentDate'];

            var jobsite = table_filters['incident.JobsiteId'];
            filters['incident.JobsiteId'] = jobsite && jobsite.hasOwnProperty('JobsiteId') ? jobsite['JobsiteId'] : null;

            return filters;
        },
        getPreviousData: function() {
            let filters = null;
            if(this.savedFilter)
            {
                filters = this.extractFilters();
                // Only these specific date filters have previous data
                if (!filters['incident.IncidentDate'] || (filters['incident.IncidentDate'].split(':')[0] != 'rolling' && filters['incident.IncidentDate'] != 'mtd' && filters['incident.IncidentDate'] != 'ytd'))
                {
                    this.$emit('prevIncidentTypeListCount', undefined);
                    return;
                }
                filters['incident.IncidentDate'] = 'prev_'+filters['incident.IncidentDate'];
            }
            else
            {
                //Set the filters
                filters = {
                    'incident.IncidentDate': 'prev_'+this.timeFilter.toLowerCase(),
                };
            }

            this.$http.get('/dash/grouped-incidents', {'groupType': 'IncidentType', 'filters': filters})
            .then(response => {
                this.$emit('prevIncidentTypeListCount', this.calcIncidentCount(response.data.data));
            })
            .catch(err => {

            })
            .then(() => {

            });
        },
        calcIncidentCount(data) {
            let count = 0;
            for (let type of data)
            {
                count += type.incident_count;
            }
            return count;
        },
    },

    mounted() {
        if (this.savedFilterId)
        {
            for(let i = 0; i < this.$store.state.user.filters.length; i++)
            {
                if (this.$store.state.user.filters[i].id == this.savedFilterId)
                {
                    this.savedFilter = this.$store.state.user.filters[i];
                    break;
                }
            }
        }
    }
}
</script>
